import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  ButtonModule,
  FitTextModule,
  FormFieldModule,
  TextsFilterComponent,
} from '@shared/components/games';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { BreakReadingControllerComponent } from './break-reading-controller/break-reading-controller.component';
import { BreakReadingCorrectAnswerPreviewComponent } from './break-reading-preview/break-reading-answer-preview/break-reading-answer-preview.component';
import { BreakReadingExamplePreviewComponent } from './break-reading-preview/break-reading-example-preview/break-reading-example-preview.component';
import { BreakReadingParametersPreviewComponent } from './break-reading-preview/break-reading-parameters-preview/break-reading-parameters-preview.component';
import { BreakReadingUserAnswerPreviewComponent } from './break-reading-preview/break-reading-user-answer-preview/break-reading-user-answer-preview.component';
import { BreakReadingSettingsComponent } from './break-reading-settings/break-reading-settings.component';
import { SharedModule } from '@games/speed-reading/shared/shared.module';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { FontParametersModule } from '../../../shared/components/games/font-parameters/font-parameters.module';
import { TextGamesSharedModule } from '@games/games-shared/text-games-shared.module';
import { MatTooltip } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    BreakReadingControllerComponent,
    BreakReadingSettingsComponent,
    BreakReadingCorrectAnswerPreviewComponent,
    BreakReadingExamplePreviewComponent,
    BreakReadingParametersPreviewComponent,
    BreakReadingUserAnswerPreviewComponent,
  ],
  exports: [
    BreakReadingControllerComponent,
    BreakReadingSettingsComponent,
    BreakReadingCorrectAnswerPreviewComponent,
    BreakReadingExamplePreviewComponent,
    BreakReadingParametersPreviewComponent,
    BreakReadingUserAnswerPreviewComponent,
    NgSelectModule,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ButtonModule,
    FitTextModule,
    NgSelectModule,
    TextsFilterComponent,
    TextGamesSharedModule,
    GamesSharedModule,
    FontParametersModule,
    FormFieldModule,
    MatTooltip,
  ],
})
export class BreakReadingModule {}
